import styles from "./TapArea.module.css";

const TapArea = ({
  style,
  onClick
}) => {
  return (
    <div className={ `${styles.nav } ${style}` } onClick={onClick}> </div>
  );
};

export default TapArea;
